import Fichar from 'components/fichajes/Fichar'
import React from 'react'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'

const ViewEmpleadoFichaje = () => {
    
  return (
    <>
        <Row>
            <Col>
            <Card>
                <CardHeader>
                    Fichar
                </CardHeader>
                <CardBody>

                    <Fichar></Fichar>
                </CardBody>

            </Card>
            </Col>
        </Row>
    </>
  )
}

export default ViewEmpleadoFichaje